module.exports = __webpack_public_path__ + "m-header-logo-blue-da1e4841.svg";